import { render, staticRenderFns } from "./ChartsTimeNumber.vue?vue&type=template&id=2f9c8160&"
import script from "./ChartsTimeNumber.vue?vue&type=script&lang=js&"
export * from "./ChartsTimeNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports